import "whatwg-fetch"; // Polyfill for Fetch for IE.

import { EnviroConfig } from "../../EnviroConfig";

import { IOption } from "../classes/option";
import { IRecurrence } from "../classes/recurrencePattern";

import { IAddOrEditEvent, IAddOrEditEventResponse } from "../classes/event";

import { formatYYYYMMDDHHMMSS } from "../reducers/changeTimePeriod";

export class DataService {

  public calendarSettings(portletInstanceId: number, calendarId: number): Promise<Response> {
    const url = "Modern_CalendarSettings";

    const searchParams = { portletInstanceId, calendarId };
    const body = JSON.stringify(searchParams);

    return this.callFetch(url, body);
  }

  public textForAddOrEditEvent(portletInstanceId: number, calendarId: number, eventId: number): Promise<Response> {
    const url = "Modern_CalendarSettings_AddEditEvent";

    const searchParams = { portletInstanceId, calendarId, eventId };
    const body = JSON.stringify(searchParams);

    return this.callFetch(url, body);
  }

  public events(portletInstanceId: number, calendarId: number, otherCalendarIds: number[], localFromDate: Date, localToDate: Date, filterFieldValue: string, searchText: string, categoryFieldValue: string, filterOptions: IOption[]): any {
    const url = "Modern_Events";

    const allCalendarIds = otherCalendarIds.slice();
    allCalendarIds.push(calendarId);

    const searchParams = { portletInstanceId, primaryCalendarId: calendarId, calendarIds: allCalendarIds, localFromDate, localToDate, filterFieldValue, searchText, categoryFieldValue, filterOptions };
    const body = JSON.stringify(searchParams);

    return this.callFetch(url, body);
  }

  public eventDetail(portletInstanceId: number, calendarId: number, eventId: number, localStartDate: Date, localEndDate: Date): any {
    const url = "Modern_EventDetail";

    const strLocalStartDate = formatYYYYMMDDHHMMSS(localStartDate);
    const strLocalEndDate = formatYYYYMMDDHHMMSS(localEndDate);

    const searchParams = { portletInstanceId, calendarId, eventId, localStartDate: strLocalStartDate, localEndDate: strLocalEndDate};
    const body = JSON.stringify(searchParams);

    return this.callFetch(url, body);
  }

  public serversForCalendar(portletInstanceId: number, calendarId: number): any {
    const url = "Modern_ServersForCalendar";

    const searchParams = { portletInstanceId, calendarId };
    const body = JSON.stringify(searchParams);

    return this.callFetch(url, body);
  }

  public calendarPagesForServer(portletInstanceId: number, serverId: number, calendarId: number): any {
    const url = "Modern_CalendarPagesForServer";

    const searchParams = { portletInstanceId, serverId, calendarId };
    const body = JSON.stringify(searchParams);

    return this.callFetch(url, body);
  }

  public unregisterFromEvent(eventId: number, calendarId: number, localStartDate: Date, localEndDate: Date): any {
    const url = "Modern_UnregisterFromEvent";

    const searchParams = { eventId, calendarId, localStartDate, localEndDate };
    const body = JSON.stringify(searchParams);

    return this.callFetch(url, body);
  }

  public registerForEvent(eventId: number, calendarId: number): any {
    const url = "Modern_RegisterForEvent";

    const searchParams = { eventId, calendarId };
    const body = JSON.stringify(searchParams);

    return this.callFetch(url, body);
  }

  public deleteEvent(portletInstanceId: number, objectId: number, parentId: number, contextId: number, deleteThisEventInstanceOnly: boolean, eventInstanceDate: Date): any {
    const url = "Modern_DeleteEvent";

    const searchParams = { portletInstanceId, objectId, parentId, contextId, deleteThisEventInstanceOnly, eventInstanceDate };
    const body = JSON.stringify(searchParams);

    return this.callFetch(url, body);
  }

  public exportFile(calendarId: number, eventId: number, isAllDay: boolean, title: string, location: string, description: string, category: string, localStartDate: Date, localEndDate: Date): any {
    const url = "Modern_ExportFile";

    const searchParams = { calendarId, eventId, isAllDay, title, location, description, category, localStartDate, localEndDate };
    const body = JSON.stringify(searchParams);

    return this.callFetch(url, body);
  }

  public addOrEditEvent(event: IAddOrEditEvent): any {
    const url = "Modern_AddOrEditEvent";
    const theEvent = { theEvent: event };
    const body = JSON.stringify(theEvent);
    return this.callFetch(url, body);
  }

  public latestDateNowForUser(): any {
    const url = "Modern_LatestDateNowForUser";
    const body = "";
    return this.callFetch(url, body);
  }

  public updateRecurrenceDescription(recurrence: IRecurrence, dateOfFirstEventInRecurrence: Date, firstDayOfWeek: string): any {

    const url = "Modern_RecurrenceDescription";
    const searchParams = { recurrence: JSON.stringify(recurrence), dateOfFirstEventInRecurrence, firstDayOfWeek };
    const body = JSON.stringify(searchParams);
    return this.callFetch(url, body);
  }

  private callFetch(url: string, body: string): Promise<Response> {

    const headers = new Headers();
    headers.append("Accept", "application/json, text/javascript, */*; q=0.01");
    headers.append("Content-Type", "application/json; charset=UTF-8");

    const config = new EnviroConfig();
    const baseURL = config.calendarServiceURL;

    return fetch(baseURL + url, { method: "POST", headers, body, credentials: "same-origin" }).then((response) => {
      let result: any = {};
      if (response.ok) {
        result = response.json();
      } else {
        result.error = url + ": " + response.statusText;
      }
      return result;
    }).catch((error) => {
      const result: any = {};
      result.error = error;
      return url + ": " + result;
    });
  }

}
